import { LightningElement, api } from "lwc";
import { c as classNames } from "tds/chunk_index";
import { attrToBool } from "common/helpers";
import input$1 from "./input.html";
import inputSearch from "./inputSearch.html";
import inputCheckbox from "./inputCheckbox.html";
import inputRadio from "./inputRadio.html";
import inputToggle from "./inputToggle.html";

function isToggleable(type) {
  return !!(type && ["checkbox", "radio", "toggle"].includes(type));
}
function isSearch(type) {
  return type === "search";
}
class input extends LightningElement {
  @api ariaInvalid = null;
  @api ariaLabel = null;
  @api autocomplete = "off";
  @api busy = false;
  @api checked = false;
  @api disabled = false;
  @api errorMessage = null;
  @api label = null;
  @api name = null;
  @api placeholder = null;
  @api required = null;
  @api type = "text";
  @api value = "";
  @api readOnly = false;
  @api toggleLabels = {
    toggleEnabled: "",
    toggleDisabled: "",
  };

  @api focus() {
    this.template.querySelector("input")?.focus();
  }

  render() {
    switch (this.type) {
      case "search":
        return inputSearch;

      case "checkbox":
        return inputCheckbox;

      case "radio":
        return inputRadio;

      case "toggle":
        return inputToggle;

      default:
        return input$1;
    }
  }

  get _value() {
    return typeof this.value === "string" ? this.value : null;
  }

  get className() {
    return classNames("input", {
      "input--disabled": this.isDisabled,
      "input--errored": this.hasError,
    });
  }

  get labelClasses() {
    return classNames("label", {
      "label--required": this.isRequired,
    });
  }

  get showClearButton() {
    return this._value && !this.isBusy;
  }

  get isDisabled() {
    return attrToBool(this.disabled);
  }

  get isRequired() {
    return attrToBool(this.required);
  }

  get isInvalid() {
    if (this.ariaInvalid || attrToBool(this.ariaInvalid)) {
      return attrToBool(this.ariaInvalid);
    }

    if ((this.isRequired && !this._value) || this.hasError) {
      return true;
    }

    return false;
  }

  get isTypeText() {
    return this.type === "text";
  }

  get isBusy() {
    return attrToBool(this.busy);
  }

  get isChecked() {
    return attrToBool(this.checked);
  }

  handleChange(e) {
    if (isToggleable(this.type)) {
      return this.dispatchEvent(
        new CustomEvent("change", {
          detail: e.target.checked,
        })
      );
    }

    if (isSearch(this.type)) {
      this.value = e.target.value;
    }

    this.dispatchEvent(
      new CustomEvent("change", {
        detail: e.target.value,
      })
    );
  }

  handleClearValue(e) {
    e.preventDefault();
    this.value = "";
    this.dispatchEvent(
      new CustomEvent("change", {
        detail: "",
      })
    );
  }

  get hasError() {
    return !!this.errorMessage;
  }

  handleKeyUp(e) {
    const input = e.target;

    if (this.ariaInvalid || attrToBool(this.ariaInvalid)) {
      return attrToBool(this.ariaInvalid);
    }

    if (this.isRequired) {
      input.value
        ? input.setAttribute("aria-invalid", "false")
        : input.setAttribute("aria-invalid", "true");
    }
  }

  get isReadOnly() {
    return attrToBool(this.readOnly);
  }
}

export default input;
export { isSearch, isToggleable };
